import React, { useRef, useState } from 'react';
import { SearchBox } from './searchBox';
import { HeaderButtonSet } from './headerMenuButtons';
import { retrieveUserData, userHasAccess, isCompanyAdmin } from '../../supplementary_components/userDataDelegate';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { AddButtonWithTitle } from '../content_management/reusableItems/buttons';
import { Form } from '../forms/Form';
import { addPopup } from '../../supplementary_components/store';
import { setCompany, addCompanyToCompanyList } from '../../supplementary_components/companySettings';
import { COMPANY_ADD_CONF } from '../../pages/company/comapnyAddConf';
import styles from './header.module.scss';

export const Header = ({ company }) => {
    const currentUser = retrieveUserData();
    currentUser.accessibleCompanies = typeof (currentUser.accessibleCompanies) === 'string' ? JSON.parse(currentUser.accessibleCompanies) : currentUser.accessibleCompanies;
    if (!Array.isArray(currentUser.accessibleCompanies)) {
        currentUser.accessibleCompanies = [];
    }

    const [downButtonClicked, setDownButtonClicked] = useState(false);
    const ref = useRef(null);

    function clickAnywhere() {
        const tag = document.getElementById('arrowDown');
        if (tag && tag.getAttribute("data-open") === 'true') {
            setTimeout(() => tag.setAttribute("data-open", 'false'), 20);
            setDownButtonClicked(false);
        }
    }

    const companyNameClicked = (e) => {
        if (e.target.nextSibling && e.target.nextSibling.id === 'arrowDown' && e.target.nextSibling.getAttribute("data-open") === 'false') {
            e.target.nextSibling.click();
        }
    };

    const openSelectionBox = (e) => {
        let arrowDownTag = e.target;
        while (arrowDownTag && arrowDownTag.id !== 'arrowDown') {
            arrowDownTag = arrowDownTag.parentNode;
        }
        if (arrowDownTag && arrowDownTag.getAttribute("data-listener-added") === 'false') {
            arrowDownTag.setAttribute("data-listener-added", 'true');
            document.body.addEventListener("click", clickAnywhere, true);
        }
        if (!downButtonClicked) {
            arrowDownTag?.setAttribute("data-open", 'true');
            setDownButtonClicked(true);
        }
    };

    const moreThanOneCompany = (currentUser.accessibleCompanies?.length || 0) > 1 || isCompanyAdmin();

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.companyBox}>
                    {company ? (
                        <>
                            <div className={styles.companyLogo} />
                            <div
                                id="currentCompanyNameContainer"
                                data-company-id={company.id}
                                ref={ref}
                                onClick={companyNameClicked}
                                className={`${styles.companyName} ${moreThanOneCompany ? styles.selectable : ''} ${downButtonClicked ? styles.selectionBoxOpen : ''}`}
                            >
                                {company.companyName ? company.companyName.toUpperCase() : company.companyName}
                            </div>
                            {moreThanOneCompany && (
                                <>
                                    <div id="arrowDown" data-open="false" data-listener-added="false" className={styles.downArrow} onClick={openSelectionBox}>
                                        {downButtonClicked ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                    </div>
                                    <div
                                        style={{
                                            width: downButtonClicked ? `${ref.current?.clientWidth ?? 200}px` : '15rem',
                                            display: downButtonClicked ? 'block' : 'none'
                                        }}
                                        className={styles.companySelection}
                                    >
                                        {currentUser.accessibleCompanies.sort((a, b) => a.id - b.id).map((value, index) => {
                                            try {
                                                if (value.companyName !== company.companyName) {
                                                    return (
                                                        <div
                                                            key={index}
                                                            onClick={() => {
                                                                setCompany(value);
                                                                window.location.href = document.location.origin;
                                                            }}
                                                        >
                                                            {value.companyName.toUpperCase()}
                                                        </div>
                                                    );
                                                }
                                            } catch (error) { }
                                            return null;
                                        })}
                                        {isCompanyAdmin() && (
                                            <AddButtonWithTitle
                                                title="Add Company"
                                                onClick={() => {
                                                    if (userHasAccess(COMPANY_ADD_CONF.formAccessLevel)) {
                                                        addPopup({
                                                            content: Form,
                                                            popupData: { configuration: COMPANY_ADD_CONF },
                                                            postSuccessAction: (e) => {
                                                                addCompanyToCompanyList(currentUser.accessibleCompanies, e);
                                                                setCompany(e);
                                                                window.location.href = document.location.origin;
                                                            },
                                                            EZCloseAllowed: false
                                                        });
                                                    }
                                                }}
                                            />
                                        )}
                                    </div>
                                </>
                            )}
                        </>
                    ) : (
                        <div className={styles.companyName} />
                    )}
                </div>
                <div className={styles.searchCentered}>
                    <SearchBox />
                </div>
                <HeaderButtonSet />
            </div>
        </div>
    );
};
